import React, { ReactNode } from "react";
import { Button, ButtonProps } from "@mui/material";

interface AppNoFocusButtonProps extends ButtonProps {
  children: ReactNode;
}

const AppNoFocusButton: React.FC<AppNoFocusButtonProps> = ({
  children,
  sx,
  ...props
}) => {
  return (
    <Button
      disableRipple
      {...props}
      sx={{
        ...sx,
        "&:focus": {
          outline: "none",
        },
        "&:focus-visible": {
          outline: "none",
        },
        "&:hover": {
          backgroundColor: "transparent",
        },
      }}
    >
      {children}
    </Button>
  );
};

export default AppNoFocusButton;
